'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import Modal from 'react-modal';

import Analytics from '@utils/Analytics';
import CoverImagePicker from '@components/Widgets/CoverImagePicker.react';
import ContactFormModal from '@components/Widgets/ContactFormModal.react';

import defaultImages from '@tables/cover-images.js';

import '@components/Widgets/CoverImagePicker.scss';
import { getConfig } from '@utils/Env';
import AuthStore from '@stores/AuthStore';

import './CollectionToPdfButton.scss';

export default class CollectionToPdfButton extends Component {

    static propTypes = {
        button: PropTypes.node,
        classes: PropTypes.string,
        collection: PropTypes.object,
        profileUuid: PropTypes.string,
    };

    static contextTypes = {
        isPro: PropTypes.bool,
        isCordova: PropTypes.bool,
    };

    constructor(props, context) {
        super(props, context);

        const { profileUuid } = props;

        const params = { profileUuid };

        let cover_images = defaultImages.slice();

        if (context.isCordova) {
            params.token = AuthStore.getToken();
        }

        this.state = {
            params,

            cover_images,
        }
    }

    toggleParam = (key) => {
        const { params } = this.state;

        if (params[key]) {
            delete params[key];
        } else {
            params[key] = 1;
        }

        this.setState({params});
    }

    setIngredientMode = (mode) => {
        const { params } = this.state;

        if (!mode) {
            delete params.ingr_mode;
        } else {
            params.ingr_mode = mode;
        }

        this.setState({params});
    }

    trackPdfDownload = () => {
        const { collection } = this.props;
        Analytics.downloadCollectionPDF({'Collection UUID': collection.uuid});
    }

    openModal = () => {
        this.setState({isModalOpen: true});
    }

    closeModal = () => {
        this.setState({isModalOpen: false});
    }

    setCoverImage = (url) => {
        const { params } = this.state;

        params.cover_image = url;

        this.setState({params});
    }

    onChangeCoverImage = ({ url }) => {
        const { cover_images, params } = this.state;

        if (url && !cover_images.includes(url)) {
            cover_images.push(url);
        }

        params.cover_image = url;

        this.setState({ cover_images, params });
    }

    renderPdfDialog = () => {
        const { params, cover_images, isModalOpen } = this.state;
        const { collection } = this.props;
        const { isPro } = this.context;

        if (!isModalOpen) {
            return null;
        }

        const using = params.cover_image || cover_images[0];
        const toPdfUrl = (`https://${getConfig('self_host')}/collections/${collection.uuid}/printable?`) + qs.stringify(params);

        return (
            <Modal isOpen={true}
                closeModal={this.closeModal}
                contentLabel="Recipe Collection Print Options"
                className="el-modal el-modal2"
                overlayClassName="el-modal-overlay"
                closeTimeoutMS={250}>

                <div className="el-modal-container el-modal2-container">
                    <header>
                        <h2>Recipe Collection Print Options</h2>
                        <button className="el-modal-close-x" onClick={this.closeModal}>
                            <i className="icon-close-x" />
                            <span className="assistive-text">Close Modal</span>
                        </button>
                    </header>

                    <div className="el-modal-body-container el-modal2-body-container el-fonts">
                        <div className="plan-to-pdf-form collection-to-pdf-form">

                            <h3>Include:</h3>
                            <div className="toggle-group">
                                <button className="toggle-btn" data-selected={params.hide_cover ? false : true} onClick={() => this.toggleParam('hide_cover')}>
                                    Cover Page
                                </button>

                                <button className="toggle-btn" data-selected={params.hide_photos ? false : true} onClick={() => this.toggleParam('hide_photos')}>
                                    Recipe Photos
                                </button>
                            </div>

                            <h3>Ingredients Options:</h3>
                            <div className="toggle-group">
                                <button className="toggle-btn radio-btn" data-selected={params.ingr_mode == 'default' || !params.ingr_mode} onClick={() => this.setIngredientMode()}>
                                    Cups
                                </button>

                                <button className="toggle-btn radio-btn" data-selected={params.ingr_mode == 'grams'} onClick={() => this.setIngredientMode('grams')}>
                                    Grams
                                </button>

                                <button className="toggle-btn radio-btn" data-selected={params.ingr_mode == 'ounces'} onClick={() => this.setIngredientMode('ounces')}>
                                    Ounces
                                </button>
                            </div>

                            <h3>Cover Image:</h3>
                            <CoverImagePicker
                                selectedImage={using}
                                availableImages={cover_images}
                                onImageSelect={this.setCoverImage}
                                onImageUpload={this.onChangeCoverImage}
                                showDimensions={false}
                                uploadOption={false}
                            />

                            {isPro ?
                                <p className="admonition">
                                WARNING: This recipe book may contain content, which is licensed for distribution only to&nbsp;
                                your current clients. If you'd like to use this content for other purposes, please contact&nbsp;
                                <ContactFormModal defaultSubject="sales" sourceLabel="Recipe Collection PDF - Licensing Inquiry">support@eatlove.is</ContactFormModal><br /><br />
                                You may also enter and exclusively use your own recipe content for which you may share for any purpose.
                                </p>
                            : null}

                            {!isPro ?
                                <p className="admonition">
                                WARNING: This recipe book may contain content, which is licensed for your personal use only.&nbsp;
                                If you'd like to use this content for other purposes, please contact&nbsp;
                                <ContactFormModal defaultSubject="sales" sourceLabel="Recipe Collection PDF - Licensing Inquiry">support@eatlove.is</ContactFormModal><br /><br />
                                You may also enter and exclusively use your own recipe content for which you may share for any purpose.
                                </p>
                            : null}
                        </div>
                    </div>

                    <footer>
                        <button className="el-modal-cancel-btn" onClick={this.closeModal}>Close</button>
                        <a target="_blank" onClick={this.trackPdfDownload} href={toPdfUrl}>
                            <button className="el-modal-ok-btn">Generate</button>
                        </a>
                    </footer>
                </div>
            </Modal>
        );
    }


    render = () => {
        const { classes, button } = this.props;

        return (
            <>
                <button className={classes || "ok-btn"} onClick={this.openModal}>{button || <i className="icon-print" />}</button>
                {this.renderPdfDialog()}
            </>
        );
    }
}
